import { useTranslation } from 'react-i18next';
import type { StaticSharedField } from './types';
import {
  ERR_TYPE_ENUM_IS_DROPDOWN,
  ERR_TYPE_REQUIRED,
  FIELD_TYPE_SEARCHABLE_DROPDOWN,
} from '/business/shared/components/questions/helper/fieldEnums';

export type refrigerantType = {
  group: string;
  name: string;
  displayName: string;
  units: string[];
};

export default function useRefrigerantType(refrigerantTypes: refrigerantType[]): StaticSharedField {
  const { t } = useTranslation();

  return {
    type: FIELD_TYPE_SEARCHABLE_DROPDOWN,
    element: 'refrigerant_type',
    propName: 'emission_source',
    label: 'Emission source:',
    placeholderI18nKey: 'business:QuestionPage.forms.refrigerants.refrigerantPlaceholder',
    dropdownTitleI18nKey: 'business:QuestionPage.forms.refrigerants.dropdownTitle',
    values: refrigerantTypes,
    styleInputParentWidth: '20rem',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOREFRIGERANTTYPE',
        errStr: t('business:Errors.refrigerant.provideType'),
      },
      {
        rule: ERR_TYPE_ENUM_IS_DROPDOWN,
        errCode: 'ERRREFRIGERANTTYPENOTFOUND',
        errStr: t('business:Errors.refrigerant.notFound'),
      },
    ],
  };
}
